export const StatsTypes = {
  TICK_INFO: 'TickInfo',
  EPOCH_INFO: 'EpochInfo',
  POOL_INFO: 'PoolInfo',
}

export const PoolInfoTypes = {
  POOL_INFO: 'PoolInfo',
  POOL_STATS: 'PoolStats',
}